import React from 'react';
import PropTypes from 'prop-types';
import useAccessibility from 'hooks/useAccessibility';
import accessClasses from 'styles/accessClasses.css';
import VilleDeNoelEffects from 'components/VilleDeNoel/VilleDeNoelEffects';

const Layout = ({ children }) => {
  const accessibilityVariant = useAccessibility();

  return (
    <div className={`main-wrapper ${accessibilityVariant}`}>
      {children}
      <VilleDeNoelEffects />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
